import React from 'react';
import { motion } from 'framer-motion';
import { Heart, DollarSign, Users, AlertCircle } from 'lucide-react';
const pains = [{
  icon: DollarSign,
  quote: 'Meu orçamento está mega apertado e ainda falta as lembrancinhas 😧',
  emotion: 'Se for R$1 por lembrancinha, já dá R$250... e eu nem sei se vai ficar bonito.'
}, {
  icon: AlertCircle,
  quote: 'Tenho medo de ser muito simples...',
  emotion: "E se as pessoas acharem que eu não me esforcei? E se parecer 'pobrezinho'?"
}, {
  icon: Heart,
  quote: 'Eu pesquisei bastante... queria fazer algo além do bem-casado',
  emotion: 'Mas tudo que eu vejo é caro demais ou parece impossível de fazer.'
}, {
  icon: Users,
  quote: 'De início nem ia ter lembrancinha...',
  emotion: 'Mas todo mundo espera. E eu não quero decepcionar ninguém no meu próprio casamento.'
}];
export function PainSection() {
  return <section className="py-24 bg-white" data-id="element-157">
      <div className="max-w-6xl mx-auto px-6" data-id="element-158">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-159">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-160">
            Isso dói porque é verdade...
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-161">
            Você não está sozinha. Milhares de noivas brasileiras sentem
            exatamente o mesmo que você.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-162">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.6
        }} className="bg-gradient-to-br from-rose-50 to-pink-50 p-8 rounded-2xl shadow-lg border border-rose-100" data-id="element-163">
              <div className="flex items-start gap-4 mb-4" data-id="element-164">
                <div className="bg-white p-3 rounded-full shadow-md" data-id="element-165">
                  <pain.icon className="w-6 h-6 text-rose-500" data-id="element-166" />
                </div>
                <div className="flex-1" data-id="element-167">
                  <p className="text-lg font-semibold text-gray-800 mb-3 italic" data-id="element-168">
                    "{pain.quote}"
                  </p>
                  <p className="text-gray-600 leading-relaxed" data-id="element-169">
                    {pain.emotion}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="mt-16 text-center" data-id="element-170">
          <div className="bg-rose-100 border-l-4 border-rose-500 p-8 rounded-lg max-w-3xl mx-auto" data-id="element-171">
            <p className="text-xl text-gray-800 leading-relaxed" data-id="element-172">
              <span className="font-bold" data-id="element-173">A verdade é:</span> você não tem medo
              de gastar pouco. Você tem medo de{' '}
              <span className="font-bold text-rose-600" data-id="element-174">
                parecer que gastou pouco
              </span>
              . E isso muda tudo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}